const AlertMessage = {
  400_006: {
    en: 'You have written more than 5 articles. Please write again after 00:00.',
    ko: '하루 게시글 작성 제한은 5개 입니다. 내일 다시 시도해주세요.',
  },
  401_002: {
    en: 'Your account information has been terminated. Please log in again.',
    ko: '계정 정보가 만료되었습니다. 다시 로그인 진행해 주세요.',
  },
  401_012: {
    en: 'You have already logged in. Please change the options and log in.',
    ko: '이미 로그인한 기록이 있습니다. 옵션을 변경해서 로그인해 주세요.',
  },
  401_902: {
    en: 'Your access has been blocked due to malicious comments and inappropriate messenger use.',
    ko: '악성댓글 및 부적절한 메신저 사용으로 이용이 차단되었습니다.',
  },
  413_001: {
    en: 'A nickname already exists. Please change your nickname',
    ko: '이미 존재하는 닉네임이 있습니다. 닉네임을 변경해 주세요.',
  },

  500_000: {
    en: 'There is a problem with the API call',
    ko: 'API호출에 문제가 있습니다.',
  },
  500_001: {
    en: 'There is a problem with the API call',
    ko: 'API호출에 문제가 있습니다.',
  },

  insert_nick: {
    en: 'Please enter your nickname and try logging in.',
    ko: '닉네임을 입력한 뒤 로그인을 시도해 주세요.',
  },
  insert_nick_2: {
    en: 'Please enter your nickname and change it.',
    ko: '닉네임을 입력한 뒤 닉네임 변경을 시도해 주세요.',
  },
  unknown: {
    en: 'Unkown ERROR',
    ko: '알 수 없는 에러',
  },
};

export default AlertMessage;
